import React, { useState, useEffect, useRef, useMemo, useCallback } from "react";
import Select from "react-select";
import Button from "react-bootstrap/Button";
import Col from "react-bootstrap/Col";
import Form from "react-bootstrap/Form";
import Row from "react-bootstrap/Row";
import Modal from "react-bootstrap/Modal";
import axios from "axios";
import { getUserDetails } from "../components/sidebar/Sidenav";
import { getAuthToken } from "../api/api";
import Tooltip from "../components/common/ToolTip";
import { ReactComponent as Close } from "../../src/icons-svg/icons/close.svg";
import {
  getAPIUrl,
  ValidateInputField,
  notify,
} from "../components/common/helpers";
import "../styles/Modal.css";
import {DraggableModalDialog} from "../components/common/DraggableModal"

const Release = (props) => {
  const { getRelease, disabledFeatures } = props;
  const inputRef = useRef(null);
  const [dropDownValues, setDropDownValues] = useState({
    siteOptions: [],
    componentTypeOptions: [],
    versionOptions: [],
  });
  const [selectedValues, setSelectedValues] = useState({
    selectedSiteValues: null,
    selectedComponentType: null,
    selectedComponentId: null,
    selectedVersion: null,
  });
  const [show, setShow] = useState(false);
  const [validated, setValidated] = useState(false);
   //Handle validations for form fields
   const [formErrors, setFormErrors] = useState({
    site: "",
  });

  const controller = new AbortController();
  
  const handleClose = () => {
    if (controller) {
      controller.abort();
    }
    setShow(false);
    setFormErrors("");

    setSelectedValues((prevState) => ({
      ...prevState,
      selectedSiteValues: null,
      selectedComponentType: null,
      selectedVersion: null,
    }));
    setDropDownValues((prevState) => ({
      ...prevState,
      componentTypeOptions: [],
      versionOptions: [],
    }));
  };

  const handleShow = () => setShow(true);

  // Get Site dropdown values
  useEffect(() => {
    if (show) {
      inputRef.current.focus();
      axios({
        method: "GET",
        url: getAPIUrl("getSiteListApi"),
        headers: { Authorization: getAuthToken() },
        signal: controller.signal,
      })
        .then((res) => {
          let formatOption;
          if (res && res.data.code !== 404) {
            formatOption = res.data.map((item) => ({
              value: item.site_id,
              label: item.building_name,
            }));
          } else {
            formatOption = [];
          }
          setDropDownValues((prevState) => ({
            ...prevState,
            siteOptions: formatOption,
          }));
        })
        .catch((err) => {
          setDropDownValues((prevState) => ({
            ...prevState,
            siteOptions: [],
          }))
          console.log(err);
        });
    }

    return () => {
      controller.abort();
    };
  }, [show]);

  // Get component Type dropdown values
  useEffect(() => {
    if (show && selectedValues.selectedSiteValues !== null) {
      const siteParamsFormation = selectedValues.selectedSiteValues.length !== 0 ? 
      `?site_id=${selectedValues.selectedSiteValues.toString()}` : `?site_id=`;

      axios({
        method: "GET",
        url: getAPIUrl("getComponentType") + siteParamsFormation,
        headers: { Authorization: getAuthToken() },
        signal: controller.signal,
      })
        .then((res) => {
          let formateOptions;
          if(res) {
            formateOptions = res.data.map((item) => ({
              value: item.component_type_id,
              label: item.component_types,
            }));
          } else {
            formateOptions = [];
          }
          setDropDownValues((prevState) => ({
            ...prevState,
            componentTypeOptions: formateOptions,
          }));
          setDefaultComponentType(formateOptions);
        })
        .catch((err) => {
          console.log(err);
        });
    } 
  }, [show, selectedValues.selectedSiteValues]);

  // Get Version drodown values
  useEffect(() => {
    if (show && selectedValues.selectedSiteValues !== null) {
      const componentTypeParams = selectedValues.selectedComponentId !== null ? 
    `?compnenttype_id=${selectedValues.selectedComponentId}` : "";
      axios({
        method: "GET",
        url:
          getAPIUrl("getFirmwareVersionListApi") + componentTypeParams,
        headers: { Authorization: getAuthToken() },
        signal: controller.signal,
      })
        .then((res) => {
          let formatedOption;
          if (res && res.data.code !== 404) {
            formatedOption = res.data.map((item) => ({
              val: item.firmware_version,
            }));
          } else {
            formatedOption = [];
          }
          setDropDownValues((prevState) => ({
            ...prevState,
            versionOptions: formatedOption,
          }));
          setDefaultVersion(formatedOption);
        })
        .catch((err) => {
          console.log(err);
        });
    }
  }, [show, selectedValues.selectedComponentType]);

  // Determine the validation for enabling/disabling submit button.
  const isFormValid = useCallback(() => {
    return (
      Object.values(formErrors).every((error) => error === "valid") &&
      selectedValues.selectedSiteValues !== null && selectedValues.selectedComponentType !== null &&
      selectedValues.selectedVersion !== null
    );
  }, [selectedValues]);

  const alertMessage = (message) => {
    return message.slice(0, message.lastIndexOf(","));
  };

  const setDefaultComponentType = (formateOptions) => {
    if (formateOptions.length === 0) {
    setSelectedValues((prevState) => ({
      ...prevState,
      selectedComponentId: null,
      selectedComponentType: null,
    }));
  } else {
    setSelectedValues((prevState) => ({
      ...prevState,
      selectedComponentId: formateOptions[0].value,
      selectedComponentType: formateOptions[0].label,
    }));
  }
  };

  const setDefaultVersion = (formateOptions) => {
    if (formateOptions.length === 0) {
    setSelectedValues((prevState) => ({
      ...prevState,
      selectedVersion: null
    }));
  } else {
    setSelectedValues((prevState) => ({
      ...prevState,
      selectedVersion: formateOptions[0].val,
    }));
  }
  };

  // Handle onChange events of the dropdowns
  const handleComponentTypeChange = (event) => {
     const selectedOption = dropDownValues.componentTypeOptions.find(
      (option) => option.value === event.target.value
    );
    setSelectedValues((prevState) => ({
      ...prevState,
      selectedComponentType: selectedOption.label,
      selectedComponentId: selectedOption.value
    }))
  };

  const handleVersionChange = (e) => {
    setSelectedValues((prevState) => ({
      ...prevState,
      selectedVersion: e.target.value,
    }));
  };
  
  const handleSiteChange = (e) => {
    let siteList = [];
    Object.values(e).map((f) => siteList.push(f.value));
    setSelectedValues((prevState) => ({
      ...prevState,
      selectedSiteValues: siteList,
    }));
    const error = ValidateInputField("site", e);
    setFormErrors((prevErrors) => ({
      ...prevErrors,
      site: error,
    }));
  };

  // Handle Form submission
  const handleSubmit = (event) => {
    event.preventDefault();
    event.stopPropagation();

    const formData = new FormData(event.target);

    formData.append("createdby", getUserDetails().username);
    formData.append("site", selectedValues.selectedSiteValues.toString());
    formData.append("component_type", selectedValues.selectedComponentType);
    const formDataObj = Object.fromEntries(formData.entries());

    axios({
      method: "POST",
      url: getAPIUrl("addReleaseDetailsApi"),
      headers: { Authorization: getAuthToken() },
      signal: controller.signal,
      data: formDataObj,
    })
      .then((res) => {
        if (res && res.data.code === 201) {
          if (res.data.message !== null) {
            let alertValue = alertMessage(res.data.message);
            alert(
              `Release For ${alertValue} Already Exists And New Release Added Successfully.`
            );
            handleClose();
          } else {
            alert("Release Added Successfully");
            handleClose();
          }
        } else if (res && res.data.code === 5023) {
          if (res.data.message !== null) {
            let alertValue = alertMessage(res.data.message);
            alert(`Release For ${alertValue} Already Exists`);
          } else {
            alert("Release Already Exists");
          }
        }
        getRelease();
      })
      .catch((err) => {
        err.message !== "canceled" && notify("submission");
      });
    setValidated(false);
  };

  return (
    <>
      {!disabledFeatures.includes("AddRelease") && (
        <Button
          size="sm"
          variant="secondary"
          onClick={handleShow}
          style={{ background: "#ffffff", color: "#000000", width: "120px" }}
          disabled={disabledFeatures.includes("AddRelease")}
        >
          +Add a Release
        </Button>
      )}
      <Modal
        show={show}
        onHide={handleClose}
        backdrop="static"
        keyboard={false}
        dialogAs={DraggableModalDialog}
      >
        <Modal.Header className="cancelButton">
          <Modal.Title style={{ color: "#ffffff" }}>
            <Row>
            <Col sm={{ span: 7 }}>
            <h3>Add Release</h3>
            </Col>
            <Col sm={{ offset: 3 }}>
                <Button
                    className="col-md-8 hoverEffect"
                    size="sm" 
                    variant="Dark"
                    onClick={handleClose}
                    aria-label="Close Button"
                  >
                    <Close/>
                  </Button>
                  </Col>
                  </Row>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body style={{ background: "#212529" }}>
          <Form noValidate validated={validated} onSubmit={handleSubmit}>
            <Row className="mb-3 ">
              <Form.Group
                as={Row}
                md="12"
                className="formField"
              >
                <Form.Label
                  className="required"
                  style={{ color: "white" }}
                  size="sm"
                  column
                  sm={4}
                  htmlFor="site"
                >
                  Site
                </Form.Label>
                <Col sm={8}>
                  <div>
                    <Select
                      size="sm"
                      aria-invalid={formErrors.site === "error"}
                      isInvalid={formErrors.site === "error"}
                      isValid={formErrors.site === "valid"}
                      className={
                        formErrors.site === "error"
                          ? "error form-control form-control-sm"
                          : "form-control form-control-sm"
                      }
                      placeholder="Ex:[site1]"
                      value={dropDownValues.siteOptions.filter((obj) =>
                        selectedValues.selectedSiteValues !== null && selectedValues.selectedSiteValues.includes(obj.value)
                      )} // set selected values
                      options={dropDownValues.siteOptions} // set list of the data
                      onChange={handleSiteChange} // assign onChange function
                      isMulti
                      ref = {inputRef}
                      isClearable
                      aria-required
                      name="site"
                    />
                  </div>
                  {formErrors.site === "error" && (
                    <Tooltip type="site_selection"/>
                  )}
                </Col>
              </Form.Group>
            </Row>
            <Row className="mb-3">
              <Form.Group
                as={Row}
                md="12"
                className="formField"
              >
                <Form.Label
                  className="required"
                  style={{ color: "white" }}
                  size="sm"
                  column
                  sm={4}
                  htmlFor="component type"
                >
                  Component Type
                </Form.Label>
                <Col sm={8}>
                  <Form.Select
                    size="sm"
                    aria-required
                    name="componentid"
                    onChange={handleComponentTypeChange}
                    disabled={dropDownValues.componentTypeOptions.length === 0}
                  >
                    { dropDownValues.componentTypeOptions.length === 0 ? (
                    <option>No data available</option> ) : (
                    dropDownValues.componentTypeOptions.map((value) => {
                      return (
                        <option key={value.value} value={value.value}>
                          {value.label}
                        </option>
                      );
                    })
                  )}
                  </Form.Select>
                </Col>
                <Col sm={12}>
                  <Form.Control.Feedback type="invalid">
                    Please provide a valid component type.
                  </Form.Control.Feedback>
                </Col>
              </Form.Group>
            </Row>
            <Row className="mb-3">
              <Form.Group
                as={Row}
                md="12"
                className="formField"
                onChange={handleVersionChange}
              >
                <Form.Label
                  className="required"
                  style={{ color: "white" }}
                  size="sm"
                  column
                  sm={4}
                  htmlFor="firmware version"
                >
                  Firmware Version
                </Form.Label>
                <Col sm={8}>
                  <Form.Select
                    size="sm"
                    aria-label="Default select example"
                    name="firmwareversion"
                    aria-required
                    disabled={dropDownValues.versionOptions.length === 0}
                  >
                    {dropDownValues.versionOptions.length === 0 ? (
                      <option>No data available</option>
                    ) : (
                      dropDownValues.versionOptions.map((value, index) => {
                        return (
                          <option key={value.val} value={value.val}>
                            {value.val}
                          </option>
                        );
                      })
                    )}
                  </Form.Select>
                </Col>
                <Col sm={12}>
                  <Form.Control.Feedback type="invalid">
                    Please provide a valid component type.
                  </Form.Control.Feedback>
                </Col>
              </Form.Group>
            </Row>
            <Row>
              <Col sm={{ span: 10, offset: 2 }}>
                <Button
                  className="col-md-5"
                  size="sm"
                  variant="secondary"
                  type="submit"
                  disabled={!isFormValid()}
                >
                  Submit
                </Button>{" "}
                <Button
                  className="col-md-5"
                  size="sm"
                  variant="secondary"
                  onClick={handleClose}
                >
                  Cancel
                </Button>
              </Col>
            </Row>
          </Form>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default Release;
